import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-woning-zoeken',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconWoningZoeken {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="m35.41 23.97-7.58-7.59c-.38-.38-.88-.59-1.42-.59s-1.04.21-1.42.59-1.63-1.63-1.63-1.63a8.986 8.986 0 0 0 2.05-5.72c0-4.98-4.04-9.02-9.01-9.02S7.41 4.05 7.41 9.02s4.04 9.02 9.01 9.02c2.08 0 4-.72 5.52-1.91l1.65 1.65-.05.05c-.78.78-.78 2.05 0 2.84l7.58 7.59c.39.39.9.59 1.42.59s1.03-.2 1.42-.59l1.46-1.46a2.006 2.006 0 0 0 0-2.84Zm-18.99-7.92c-3.86 0-7.01-3.15-7.01-7.02s3.14-7.02 7.01-7.02 7.01 3.15 7.01 7.02-3.14 7.02-7.01 7.02M0 25.41V35c0 .55.45 1 1 1h7.01c.55 0 1-.45 1-1v-9.58c0-.29-.12-.56-.33-.75l-3.54-3.18c-.38-.34-.96-.34-1.34 0L.33 24.66a1 1 0 0 0-.33.74Zm6.05 6.58c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1m0-4.01c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1m4.96-2.57V35c0 .55.45 1 1 1h7.01c.55 0 1-.45 1-1v-9.58c0-.29-.12-.56-.33-.75l-3.54-3.18c-.38-.34-.96-.34-1.34 0l-3.47 3.17a1 1 0 0 0-.33.74Zm6.05 6.58c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1m0-4.01c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1"/>
</svg>

    );
  }
}
